import './cards.sass'
import {useEffect} from "react"

export default function BottomSheetCard({active = false, className = "", ...props}) {
  useEffect(() => {
    document.body.style.overflow = active ? "hidden" : ""

    return () => {
      document.body.style.overflow = ""
    }
  }, [active])

  return (
    <>
    {props.size === "full" &&
      <div
        className={["bottom-sheet-card-overlay", active ? "active" : ""].filter(Boolean).join(" ")}></div>
    }

      <div className={["bottom-sheet-card-component", active ? "active" : "", className].filter(Boolean).join(" ")}>
        {props.closeButton}
        <div className="bottom-sheet-card-container">
          {props.children}
          <div className="menu-spacer"></div>
        </div>
      </div>
    </>

  )
}